import { useState } from 'react';
import { ChevronDown, ChevronUp, Edit, Trash2 } from 'lucide-react';
import {
  Box,
  Collapse,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

import { ServiceType } from '../../types/ServiceAccordion.type';
import ServiceSubtypeList from './ServiceSubtypeList';
import TreeBranch from '../common/TreeBranch';

interface ServiceTypeCardProps {
  service: ServiceType;
  onEdit: (service: ServiceType) => void;
  onDelete: (service: ServiceType) => void;
  fetchServiceTypes: () => void;
}

const ServiceTypeCard: React.FC<ServiceTypeCardProps> = ({
  service,
  onEdit,
  onDelete,
  fetchServiceTypes,
}) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <ListItem
        disablePadding
        secondaryAction={
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 10 }}>
            <IconButton
              edge="end"
              aria-label="edit"
              onClick={() => onEdit(service)}
              sx={{ mr: 1 }}
            >
              <Edit size={18} />
            </IconButton>
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={() => onDelete(service)}
            >
              <Trash2 size={18} />
            </IconButton>
          </Box>
        }
        sx={{
          mb: 2,
          backgroundColor: 'background.paper',
          borderRadius: 1,
          boxShadow: 1,
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <ListItemButton onClick={handleToggle} dense>
          <ListItemText
            primary={
              <Typography variant="h6" component="div" fontWeight="bold">
                {service.name}
              </Typography>
            }
          />
          {open ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </ListItemButton>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <TreeBranch>
          <ServiceSubtypeList
            service={service}
            subtypes={service.subtypes}
            fetchServiceTypes={fetchServiceTypes}
          />
        </TreeBranch>
      </Collapse>
    </>
  );
};

export default ServiceTypeCard;
